<template>
  <div>
    <el-aside class="left" width="240px">
      <div class="left-large" v-cloak>
        <div class="logo">
          <img src="../assets/img/logo.png" />
        </div>
        <div class="left-side-inner">
          <ul class="nav nav-large">
            <li
              class="menu-list menu-list-large"
              v-for="(item, index) in leftList"
              :key="'A' + index"
              @mouseover="mouseOver($event, 'mouse-link')"
              @mouseleave="mouseLeave($event, 'mouse-link')"
              @click="drawerMenuList(index)"
              :class="showIndex == index ? 'mouse-link-active' : ''"
            >
              <div>
                <i class="el-icon-menu"></i>
                <span>{{ item.li }}</span>
              </div>
              <ul
                class="sub-menu-list"
                v-cloak
                v-show="item.child && item.child.length && showIndex == index"
              >
                <li
                  v-for="(child, idx) in item.child"
                  :key="'B' + idx"
                  @mouseover="mouseOver($event, 'child-mouse-link')"
                  @mouseleave="mouseLeave($event, 'child-mouse-link')"
                  :class="path == child.link ? 'active' : ''"
                  v-if="isAdmin || !child.admin"
                >
                  <router-link :to="child.link">{{ child.text }}</router-link>
                  <!-- <a :href="child.link">{{child.text}}</a> -->
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </el-aside>

    <el-header class="top-nav" height="50px">
      <div class="menu-right">
        <ul>
          <li
            class="menu-right-list"
            :class="showTopNav == 4 ? 'mouse-on' : ''"
            @mouseover="mouseOver($event, 'mouse-on')"
            @click="showTopNavMenu(4)"
            @mouseleave="mouseLeave($event, 'mouse-on')"
          >
            <div class="right-login-info">
              <!-- <img class="head-img" src="../assets/img/user-avatar.png" /> -->
              <span class="name">{{ loginName }}</span>
              <i class="type-icon el-icon-caret-bottom"></i>
            </div>
            <ul class="child-menu-list user-info-opt" v-show="showTopNav == 4">
              <i class="top-type-icon el-icon-caret-top"></i>
              <li
                @mouseover="mouseOver($event, 'active')"
                @mouseleave="mouseLeave($event, 'active')"
              >
                <a style="display: block" @click="loginOut"
                  ><i class="el-icon-delete-solid"></i> 退出登录
                </a>
              </li>
            </ul>
          </li>
          <div class="clear"></div>
        </ul>
      </div>
    </el-header>
  </div>
</template>

<script>
import { loginOut } from "../api/index";
import rootUrl from "../utils/api";
export default {
  name: "leftNav",
  // props: {
  //   msg: String
  // }
  data() {
    return {
      path: "",
      isAdmin:this.$store.state.isAdmin,
      leftList: [
        {
          li: "扣款管理",
          link: null,
          child: [
            {
              text: "应扣管理",
              link: "/deductible",
              admin:true,
            },
            {
              text: "实扣管理",
              link: "/",
              admin:false,
            },
            {
              text: "多人扣款",
              link: "/multiPerson",
              admin:true,
            },
            {
              text: "参数管理",
              link: "/parameter",
              admin:true,
            },
            {
              text: "部门扣款",
              link: "/dept",
              admin:true,
            },
            {
              text: "扣款项目",
              link: "/item",
              admin:true,
            },
			{
              text: "黑名单人员",
              link: "/blackList",
              admin:true,
            },
			{
			  text: "黑名单扣款",
			  link: "/chargeManage",
			  admin:true,
			},
			{
			  text: "扣款报表",
			  link: "/report",
			  admin:true,
			},
            // {
            //   text: "扣款台帐",
            //   link: "/account",
            // },
          ],
        },
      ],
      showIndex: null,
      showTopNav: null,
      loginName: this.$store.state.loginInfo.empName,
    };
  },
  mounted() {
    this.path = this.$route.path;
    // console.log(this.$route.path)
    this.getShowIndex();
    // console.log(this.$store.state.loginInfo)
  },
  methods: {
    mouseOver($event, tips) {
      $event.currentTarget.classList.add(tips);
    },
    mouseLeave($event, tips) {
      $event.currentTarget.classList.remove(tips);
      if (tips == "mouse-on") {
        this.showTopNav = null;
      }
    },
    drawerMenuList(index) {
      if (this.leftList[index].link == this.path) {
        return;
      }
      if (this.showIndex == index) {
        this.showIndex = null;
        return;
      }
      this.showIndex = index;
      if (this.leftList[index].link && this.leftList[index].link !== "") {
        this.$router.push(this.leftList[index].link);
      }
    },
    getShowIndex() {
      let that = this,
        index = 0;
      for (let i = 0, len = that.leftList.length; i < len; i++) {
        if (!that.leftList[i].child || that.leftList[i].child.length == 0) {
          continue;
        }
        if (that.leftList[i].link && that.leftList[i].link == this.path) {
          return (this.showIndex = i);
        }
        for (let j = 0, child = that.leftList[i].child.length; j < child; j++) {
          if (that.leftList[i].child[j].link == this.path) {
            return (this.showIndex = i);
          }
        }
      }
    },
    showTopNavMenu(idx) {
      if (this.showTopNav == idx) {
        this.showTopNav = null;
      } else {
        this.showTopNav = idx;
      }
    },
    loginOut() {
      loginOut().then((res) => {
        console.log(res);
        if (res.code == 200) {
          window.location.href =
                "https://cdsso.centaline.com.cn/sso/sso-loginout/loginout?clienttype=pc&appid=5e18b492-a87c-4aeb-aead-1ba590d80224&redirect_uri=" +
                encodeURIComponent(window.location.href);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/left.less";
</style>
